import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { MapPin, Phone, Mail, Globe, ArrowLeft, User, Instagram, Facebook } from "lucide-react";
import api from "@/lib/api";

export default function OfficeDetail() {
  const { id } = useParams();
  const [o, setO] = useState(null);

  useEffect(() => { window.scrollTo(0, 0); api.get(`/offices/${id}`).then((r) => setO(r.data)).catch(() => setO(false)); }, [id]);

  if (o === false) return <div className="container-page py-24 text-center text-slate-500">Kantor tidak ditemukan.</div>;
  if (!o) return <div className="container-page py-24 text-center text-slate-400">Memuat…</div>;

  return (
    <div className="container-page py-10 max-w-4xl">
      <Link to="/bawaslu-terdekat" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-brandred mb-6">
        <ArrowLeft className="h-4 w-4" /> Kembali ke Direktori
      </Link>
      <div className="bg-navy text-white rounded-2xl p-8">
        <span className="text-[11px] font-bold px-2.5 py-1 rounded-full bg-brandred">{o.level}</span>
        <h1 className="text-2xl sm:text-3xl font-extrabold mt-3">{o.name}</h1>
        <p className="text-slate-300 mt-1">{o.province}</p>
      </div>
      <div className="grid md:grid-cols-2 gap-6 mt-6">
        <div className="bg-white border border-slate-200 rounded-xl p-6 space-y-4">
          <h3 className="font-bold text-navy">Informasi Kontak</h3>
          {[
            { i: MapPin, l: "Alamat", v: o.address },
            { i: Phone, l: "Telepon", v: o.phone },
            { i: Mail, l: "Email", v: o.email },
            { i: Globe, l: "Website", v: o.website },
            { i: User, l: "Penanggung Jawab", v: o.chief },
          ].map((r) => (
            <div key={r.l} className="flex gap-3">
              <r.i className="h-5 w-5 text-brandred shrink-0 mt-0.5" />
              <div><div className="text-xs text-slate-400">{r.l}</div><div className="font-semibold text-navy text-sm">{r.v}</div></div>
            </div>
          ))}
          <div className="flex gap-3 pt-2">
            <span className="flex items-center gap-1.5 text-sm text-slate-500"><Instagram className="h-4 w-4 text-brandred" /> {o.social?.instagram}</span>
          </div>
        </div>
        <div className="bg-navy rounded-xl overflow-hidden relative flex items-center justify-center min-h-64">
          <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "linear-gradient(#1E3E6B 1px, transparent 1px), linear-gradient(90deg, #1E3E6B 1px, transparent 1px)", backgroundSize: "24px 24px" }} />
          <div className="relative text-center text-white px-6">
            <MapPin className="h-10 w-10 text-brandred mx-auto mb-2" />
            <p className="text-sm text-slate-300">Lokasi: {o.address}</p>
            <p className="text-xs text-slate-400 mt-1 font-mono">{o.lat?.toFixed(3)}, {o.lng?.toFixed(3)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
